import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const scrollBtn: SxStyleFunc<boolean | undefined> = (
  canScrollRight
) => ({
  display: canScrollRight ? 'flex' : 'none',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.common.white,
  cursor: 'pointer',
  mx: 0.5,
  ':hover': {
    borderColor: (p) => p.palette.grey[400],
    borderRadius: '50%',
  },
});

export const removeAll: SxStyleFunc<number> = (length) => ({
  justifyContent: 'center',
  display: length < 1 ? 'none' : 'flex',
  gap: 0.5,
  alignItems: 'center',
  borderWidth: '1px',
  width: (p) => p.spacing(3),
  height: (p) => p.spacing(3),
  borderStyle: 'solid',
  borderColor: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(2.5),
  cursor: 'pointer',
  mx: 0.5,
  transition: 'all 0.2s ease-in',
  '& > p': {
    textWrap: 'nowrap',
    opacity: 0,
    display: 'none',
    fontSize: (p) => p.typography.caption.fontSize,
  },
  ':hover': {
    borderColor: (p) => p.palette.grey[400],
    width: length >= 2 ? (p) => p.spacing(10.5) : (p) => p.spacing(3),
    '& > p': {
      fontSize: (p) => p.typography.caption.fontSize,
      opacity: length >= 2 ? 1 : 0,
      display: length >= 2 ? 'inline-block' : 'none',
    },
  },
});
